import { render, staticRenderFns } from "./discountServiceItem.vue?vue&type=template&id=788c2728&scoped=true&"
import script from "./discountServiceItem.vue?vue&type=script&lang=js&"
export * from "./discountServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./discountServiceItem.vue?vue&type=style&index=0&id=788c2728&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c2728",
  null
  
)

export default component.exports